const app = {
  body: document.querySelector("body"),
  header: document.querySelector(".header"),
  anim: document.querySelector(".anim-burger"),
  nav: document.querySelector(".header_nav"),
  navCtn: document.querySelector(".header_ctn"),
  navList: document.querySelector(".header_nav_list"),
  burger: document.querySelector(".header_burger"),
  hFooter: document.querySelector(".header_footer"),
  menuItm: document.querySelectorAll(".header_nav_list_link"),
  filter: document.querySelector(".filterBar_ctn"),
  bg: document.querySelector(".background_asset"),
  main: document.querySelector(".bgl"),
};

// HANDLE MARGIN TOP OF HEADER ACCORDINGLY WITH THE WP ADMIN HEADER
// const marginTopHandler = e => {
//   let st = window.scrollY
//   let w = window.innerWidth
//   let logged = app.body.classList.contains("logged-in")

//   if (logged) {
//     if (st > 0 && w <= 600) {
//       app.header.style.marginTop = "0"
//     } else if (st === 0 && w <= 600 && w <= 782) {
//       app.header.style.marginTop = "46px"
//     } else if (st === 0 && w >= 782) {
//       app.header.style.marginTop = "32px"
//     }
//   }
// }

// window.addEventListener("load", marginTopHandler)
// window.addEventListener("scroll", marginTopHandler)
// window.addEventListener("resize", marginTopHandler)

// HANDLE BURGER DISPLAY
const burgerDisplay = (e) => {
  app.anim.classList.toggle("active");
  app.nav.classList.toggle("b-opened");
  app.navList.classList.toggle("b-opened");
  app.hFooter.classList.toggle("visible");
  app.navCtn.classList.toggle("full-height");
  app.main.classList.toggle("menu-opened");
  app.body.classList.toggle("ovh");
};

const burgerClear = (e) => {
  app.anim.classList.remove("active");
  app.nav.classList.remove("b-opened");
  app.navList.classList.remove("b-opened");
  app.hFooter.classList.remove("visible");
  app.navCtn.classList.remove("full-height");
  app.main.classList.remove("menu-opened");
  app.body.classList.remove("ovh");
  if (app.filter) app.filter.classList.remove("open-filter");
};

for (let i = 0; i < app.menuItm.length; i++) {
  app.menuItm[i].addEventListener("click", burgerClear);
}

app.burger.addEventListener("click", burgerDisplay);
window.addEventListener("load", burgerClear);
window.addEventListener("resize", burgerClear);

// D I S P L A Y   F I L T E R S
if (app.filter) {
  const checkFilters = () => {
    if (app.filter.classList.contains("open-filter")) {
      app.filter.addEventListener("click", filterDisplay);
    } else {
      app.filter.removeEventListener("click", filterDisplay);
    }
  };

  const filterDisplay = (e) => {
    if (window.innerWidth <= 768) {
      checkFilters();
      app.filter.classList.toggle("open-filter");
    }
  };

  app.filter.addEventListener("click", filterDisplay);
  window.addEventListener("resize", filterDisplay);
}

// S E T  R A N D O M  B A C K G R O U N D

// I M A G E S
const bgAssets = [
  "../../img/background/desk-1.jpg",
  "../../img/background/desk-2.jpg",
  "../../img/background/desk-3.jpg",
  "../../img/background/desk-4.jpg",
  "../../img/background/desk-5.jpg",
  "../../img/background/desk-6.jpg",
];

const randomBackground = () => {
  let image = bgAssets[Math.floor(Math.random() * bgAssets.length)];

  app.bg.setAttribute("src", image);
};

// T H R O T T L E  R E S I Z E  L I S T E N E R
let resizeTimer;

const throttledRandomBg = () => {
  clearTimeout(resizeTimer);

  resizeTimer = setTimeout(randomBackground, 250);
};

// E V E N T S
// window.addEventListener('load', randomBackground)
// window.addEventListener('resize', throttledRandomBg)

if (jQuery("select").length > 0) {
  var customFilters = require("./customFilters.js");

  customFilters();
}

jQuery(".details .back-archive a.print").click(function () {
  printDiv();
});

function printDiv() {
  //var printContents = jQuery("main.bgl").html();
  //var originalContents = document.body.innerHTML;

  //document.body.innerHTML = printContents;

  window.print();

  //document.body.innerHTML = originalContents;
}

//OPINION SYSTEM NOTE
if (jQuery(".footer_trust").length > 0)
  jQuery.ajax({
    type: "POST",
    url: "//widget.opinionsystem.fr/company_rating/index.php",
    data: { company_id: 5718, os_logo: 1, os_review: 1 },
    dataType: "json",
    success: function (data) {
      console.log(data.rating, data);
      jQuery(".footer_trust")
        .find("figure")
        .append("<span>" + Math.round(data.rating) + "%" + "</span>");
      jQuery(".footer_trust")
        .find("figure")
        .append("<span>" + data.survey_total + "</span>");
    },
    error: function (jqXHR, exception, errorstr) {
      console.log(errorstr);
    },
  });

jQuery(document).ready(function () {
  if (jQuery(".random-banner").length > 0) setRandomBanner();
});

function setRandomBanner() {
  var templateUrl = object_name.templateUrl;
  var banner = jQuery(".random-banner img");

  var banners = [
    "/img/banners/fouras-by-eric-durand-1.jpg",
    "/img/banners/fouras-by-eric-durand-2.jpg",
    "/img/banners/fouras-by-eric-durand-3.jpg",
    "/img/banners/fouras-by-eric-durand-4.jpg",
    "/img/banners/fouras-by-eric-durand-5.jpg",
    "/img/banners/fouras-by-eric-durand-6.jpg",
    "/img/banners/fouras-by-eric-durand-7.jpg",
    "/img/banners/fouras-by-eric-durand-8.jpg",
    "/img/banners/fouras-by-eric-durand-9.jpg",
    "/img/banners/fouras-by-eric-durand-10.jpg",
  ];

  banner
    .attr(
      "src",
      templateUrl + banners[Math.floor(Math.random() * banners.length)]
    )
    .load(function () {
      banner.fadeIn("slow");
    });
}

if (jQuery(".contact-button").length > 0) {
  var $j = jQuery.noConflict();

  $j(".contact-button").click(function () {
    $j("#gform_wrapper_2").slideToggle("slow", function () {
    });
    $j('body,html').animate({ 'scrollTop': $j('#contact').offset().top }, 1000);
  });
}

//DPE GES MODAL
if (jQuery(".dpe-ges").length > 0) {
  jQuery(document).click(function (event) {
    //if you click on anything except the modal itself or the "open modal" link, close the modal
    if (
      !jQuery(event.target).closest(".dpe-ges, .details_energy_modal_box")
        .length
    ) {
      jQuery(".details_energy_modal").fadeOut();
    }
  });

  jQuery(".dpe-ges").click(function () {
    jQuery(".details_energy_modal").fadeIn();
  });
}

if (jQuery(".details").length > 0) {
  var count = 0;
  var images = jQuery(".details_gallery_itm");
  var arrows = jQuery(".arrow");
  var prevArrow = jQuery(".arrow--prev");
  var nextArrow = jQuery(".arrow--next");
  var bigImg = jQuery(".featured img");
  var loader = jQuery("#global_loader");

  init();

  arrows.click(function () {
    if (jQuery(this).hasClass("arrow--next")) {
      if (!prevArrow.is("visible")) {
        prevArrow.fadeIn();
      }

      if (count < images.length - 1) {
        count++;

        if (count >= images.length - 1)
          nextArrow.fadeOut();
      }
    } else {
      if (!nextArrow.is("visible"))
        nextArrow.fadeIn();

      if (count > 0) {
        count--;

        if (count < 1) {
          prevArrow.fadeOut();
        }
      }
    }

    updateActiveImg();

    updateImg();
  });

  jQuery(".featured img, .details_gallery_itm img").click(stopVideo);

  function init() {
    jQuery(images).first().addClass("active");
  }

  function updateActiveImg() {
    jQuery(images).removeClass("active");
    jQuery(images[count]).addClass("active");
  }

  function updateImg() {
    loader.fadeIn(function () {
      bigImg.parent("a").attr("href", jQuery(images[count]).find("img").attr('srcset').split(',').pop().trim().split(' ')[0]);
      bigImg.attr("src", jQuery(images[count]).find("img").attr("src"));
      bigImg.attr("srcset", jQuery(images[count]).find("img").attr('srcset').split(',').pop().trim().split(' ')[0]);

      bigImg.on('load', function () {
        loader.fadeOut();
      });
    })
  }

  function stopVideo() {
    var iframe = document.getElementsByTagName("iframe")[0].contentWindow;
    iframe.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');
  }
}
